<template>
    <div class="device device-management">
        <div class="layout">
          <div class="device-tab regional">
            <div class="system-setting">
              <!-- 主tab选择 -->
              <div class="layout-header-tab" style="width: calc(100% - 2.0625rem);z-index:22;">
                <template v-for="item in configJs">
                  <span v-if="!item.isHide" @click="tabChange(item)" :key="item.id" :class="{active: item.active || item.id === currTab.relativeId}" class="tab">{{item.name}}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <component v-bind:is="currentTabComponent" :asCom="true"></component>
    </div>
</template>

<script>
// 公用
// import Api from '@/api'
import configJs from './index'
// 组件
import deviceManagement from './components/deviceManagement'
import noStoppingZone from './components/noStoppingZone'
import forbiddenZone from './components/forbiddenZone'
import siteParam from './components/siteParam'
import siteSync from "./components/siteSync.vue";

export default {
  name: 'device-management',
  data() {
    return {
      configJs: JSON.parse(JSON.stringify(configJs))
      // currentTabComponent: 'SystemSettings'
    }
  },
  computed: {
    currTab() {
      return this.configJs.find(item => item.active)
    },
    currentTabComponent: {
      get() {
        return this.currTab.component
      },
      set(val) {}
    }
  },
  methods: {
    tabChange(item) {
      // console.log(item)
      this.configJs.forEach(item => (item.active = false))
      const currTab = this.configJs.find(it => +it.id === +item.id)
      currTab.active = true
      if (item && item.component) {
        this.currentTabComponent = item.component
      } else {
        this.currentTabComponent = undefined
      }
    }
  },
  components: {
    deviceManagement,
    noStoppingZone,
    forbiddenZone,
    siteParam,
    siteSync
  }
}
</script>

<style lang="less">
@import "../MiBicycle/miBicycle.less";
</style>
<style lang="less" scoped>
  .device-management {
    .layout.regional {
      margin-left:0px;
      z-index: 11;
    }
  }

  .layout-header {
    margin:0;
  }
</style>
